import axios from "axios";
import GetServerAddress from "../../../../../functions/GetServerAddress";

export function Post_School_Event_To_MongoDB_And_HubSpot(
  event,
  HubspotCompanyID,
  setStatus,
  Contactid
) {
  setStatus(true);

  const postData = async () => {
    try {
      const response = await axios.post(
        GetServerAddress() +
          "api/staff/Post_School_Event_To_MongoDB_And_HubSpot",
        {
          event: event,
          HubspotCompanyID: HubspotCompanyID,
          Contactid: Contactid,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`, // Include the JWT token in the request headers
            username: localStorage.getItem("Username"),
            activitylog: "Yes",
            aboutid: event.School_id ? event.School_id : "NotNoted",
          },
        }
      );
      console.log("Response Data: ", response);
      // Check for specific server response indicating an invalid auth token
      if (response.data.status === 403 || response.data.status === 401) {
        window.alert(response.data.message);

        return; // Stop further execution in case of invalid auth token
      }
      // Alert for successful POST request
      window.alert(response.data.message);
      setStatus(false);
    } catch (error) {
      console.error("Error Posting data: ", error);
      // Alert for failed POST request
      window.alert(
        "Error Posting data, please speak to Admin if this issue persists: ",
        error
      );
      setStatus(false);
    }
  };
  postData();
} // Empty dependency array means this effect runs only once
